import ACTION_TYPES from '../../constants/actionTypes';
import { uuid } from 'shared/lib/utils';

const reducers = {
  rentalCarExtensionPolicyId(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.START_RENTAL_CAR_EXTENSION:
        return action.payload.policyId;
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  rentalCarExtensionReturnDate(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.START_RENTAL_CAR_EXTENSION:
        return action.payload.dateStr;
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  rentalCarExtensionPolicy(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_POLICY_SUCCESS:
        return action.payload;
      case ACTION_TYPES.UPDATE_RENTAL_CAR_EXTENSION_CONFIRMATION_NUMBER:
        return Object.assign({}, state, {
          rental_agreement_number: action.payload.confirmationNumber,
        });
      case ACTION_TYPES.START_RENTAL_CAR_EXTENSION:
      case ACTION_TYPES.GET_RENTAL_CAR_EXTENSION:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  rentalCarExtensionCheckout(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_CHECKOUT_SUCCESS:
        return action.payload;
      case ACTION_TYPES.START_RENTAL_CAR_EXTENSION:
      case ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_CHECKOUT:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },

  rentalCarExtensionUID(state = null, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_RENTAL_CAR_EXTENSION_CHECKOUT_SUCCESS:
        return uuid();
      case ACTION_TYPES.START_RENTAL_CAR_EXTENSION:
      case ACTION_TYPES.PURCHASE_RENTAL_CAR_EXTENSION_SUCCESS:
      case ACTION_TYPES.SIGN_OUT:
        return null;
      default:
        return state;
    }
  },
};

export default reducers;
